<template>
  <div class="system-messages">
    <div>
      <v-text-field
        label="1st Slot"
        v-model="firstMessage"
        :disabled="firstMessage == null"
      ></v-text-field>
      <v-text-field
        label="2nd Slot"
        v-model="secondMessage"
        :disabled="secondMessage == null"
      ></v-text-field>
      <v-text-field
        label="3rd Slot"
        v-model="thirdMessage"
        :disabled="thirdMessage == null"
      ></v-text-field>
    </div>

    <div>
      <v-form ref="addForm">
        <v-text-field
          label="New message"
          v-model="updateField"
          @keyup.enter="addNewMessage"
          counter="255"
          :rules="textFieldRules"
        ></v-text-field>
        <v-btn class="default-action-btn" v-on:click="addNewMessage"
          >Add Message</v-btn
        >
      </v-form>
    </div>
  </div>
</template>
<script>
import titleMixin from "@/mixins/titleMixin"
import userMixin from "@/mixins/userMixin"
import validationMixin from "@/mixins/validationMixin"

export default {
  mixins: [titleMixin, userMixin, validationMixin],
  data: function() {
    return {
      title: "System Messaging",
      updateField: "",
      userId: this.$route.params.id
    }
  },
  computed: {
    messages() {
      let messages = this.$store.getters["systemMessages/getMessagesByUserId"](
        this.userId
      )
      return messages ? messages.slice(0, 3).reverse() : []
    },
    firstMessage: {
      get() {
        return this.messages.length > 0 ? this.messages[0].body : null
      },
      set(value) {
        this.$store.dispatch("systemMessages/updateMessage", {
          id: this.messages[0].id,
          body: value
        })
      }
    },
    secondMessage: {
      get() {
        return this.messages.length > 1 ? this.messages[1].body : null
      },
      set(value) {
        this.$store.dispatch("systemMessages/updateMessage", {
          id: this.messages[1].id,
          body: value
        })
      }
    },
    thirdMessage: {
      get() {
        return this.messages.length > 2 ? this.messages[2].body : null
      },
      set(value) {
        this.$store.dispatch("systemMessages/updateMessage", {
          id: this.messages[2].id,
          body: value
        })
      }
    }
  },
  created() {
    this.$store.dispatch("systemMessages/loadMessages", this.userId)
    this.$store.commit("globals/addAlert", {
      type: "info",
      text: "Test info alert"
    })
    this.$store.commit("globals/addAlert", {
      type: "warning",
      text: "Test warning alert"
    })
    this.$store.commit("globals/addAlert", {
      type: "error",
      text: "Test error alert"
    })
  },
  methods: {
    addNewMessage(e) {
      if (this.$refs.addForm.validate()) {
        this.$store.dispatch("systemMessages/addMessage", {
          toUserId: this.userId,
          body: this.updateField
        })
        this.$refs.addForm.reset()
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id
      this.$store.dispatch("systemMessages/loadMessages", this.userId)
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
